<template>
    <div class="main_container" style="overflow: initial;"
         v-loading="uploadLoading">
        <div class="configuration_main">
            <el-row :gutter="30">
                <el-col :span="8">
                    <el-upload
                            :action="baseUrl + 'api/InvoiceNew/UploadUserManual'"
                            :auto-upload="true"
                            :headers="headers"
                            :before-upload="beforeUpload"
                            :data="uploadData"
                            :limit="1"
                            :on-error="handleError"
                            :on-success="handleSuccess"
                            :show-file-list="false"
                            drag
                            ref="upload">
                        <i class="iconfont icon-shangchuan-kong upload_icon"></i>
                        <div class="el-upload__text">{{$t('message.UploadTips')}}</div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <div class="file_info">
                        <div class="file_list">
                            <div class="list_name">{{$t('message.FileName')}}</div>
                            <div class="list_value">{{fileInfo.FileName}}</div>
                        </div>
                        <div class="file_list">
                            <div class="list_name">{{$t('message.FileSize')}}</div>
                            <div class="list_value">{{fileInfo.FileSize}}</div>
                        </div>
                        <div class="file_list">
                            <div class="list_name">{{$t('message.UploadTime')}}</div>
                            <div class="list_value">{{fileInfo.CreateTime}}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {baseUrl} from "../config/env";
    import {GetUserManualDetail} from "../api/apiConfiguration";
    import {getLocal} from "../config/mUtils";

    export default {
        name: 'configuration',
        components: {},
        data() {
            return {
                headers: {
                    Authorization: 'Bearer ' + (getLocal('accessToken') || '')
                },
                baseUrl,
                uploadLoading: false,
                uploadData: {
                    Creator: getLocal('UserId'),
                },
                fileInfo: {}
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.initData();
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {
            async initData() {
                try {
                    this.getUserManualDetail();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取发票类型
            async getUserManualDetail() {
                this.uploadLoading = true;
                try {
                    let data = await GetUserManualDetail();
                    if (data.error_code === '0') {
                        this.uploadLoading = false;
                        this.fileInfo = data.data[0];
                        this.fileInfo.FileSize = (data.data[0].FileSize / 1024) > 1 ? ((data.data[0].FileSize % 1024) === 0 ? parseInt(data.data[0].FileSize / 1024) : parseFloat(data.data[0].FileSize / 1024).toFixed(2)) + 'M' : ((data.data[0].FileSize % 1) === 0 ? parseInt(data.data[0].FileSize) : parseFloat(data.data[0].FileSize).toFixed(2)) + 'KB';
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 上传前验证
            beforeUpload() {
                this.uploadLoading = true;
            },
            // 上传成功
            handleSuccess(res) {
                if (res.error_code === '0') {
                    this.$message.success(this.$t('message.UploadSuccessful'));
                    this.$refs.upload.clearFiles();
                    this.getUserManualDetail();
                } else {
                    this.$message.error(this.$t('message.UploadFailed'));
                    this.uploadLoading = false;
                    this.$refs.upload.clearFiles();
                }
            },
            // 上传失败
            handleError() {
                this.$message.error(this.$t('message.UploadFailed'));
                this.uploadLoading = false;
                this.$refs.upload.clearFiles();
            },
        }
    }
</script>

<style scoped>

</style>
